var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating1Pressed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 37C28.9411 37 37 28.9411 37 19C37 9.05888 28.9411 1 19 1C9.05888 1 1 9.05888 1 19C1 28.9411 9.05888 37 19 37Z",
    fill: "#FFF7AE",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8722 27.804C22.3762 22.904 15.3761 22.904 12.8801 27.804Z",
    fill: "#FFF7AE",
    fillOpacity: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8722 27.804C22.3762 22.904 15.3761 22.904 12.8801 27.804M37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19Z",
    stroke: "#006D5B",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2562 17.2273L25.8572 12.1428M16.5235 17.2273L11.9226 12.1428",
    stroke: "#006D5B",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating1Pressed);
export default __webpack_public_path__ + "static/media/rating-1-pressed.2f50dc9dfb666452ace26be45a20a8c4.svg";
export { ForwardRef as ReactComponent };